import { Injectable } from '@angular/core';
import { ISectionPresenter } from 'src/app/presenters/models/section-presenter';
import { AudioSmartSettingsService } from 'src/app/services/audio/audio-smart-settings/audio-smart-settings.service';
import { LoggerService } from 'src/app/services/logger/logger.service';
import { DeviceService } from 'src/app/services/device/device.service';

@Injectable({
	providedIn: 'root',
})
export class AudioSmartSection implements ISectionPresenter {
	constructor(
		private audioSmartSettingsService: AudioSmartSettingsService,
		private logger: LoggerService,
		private deviceService: DeviceService
	) {}

	public async isVisible(): Promise<boolean> {
		this.logger.info('AudioPage - AudioSmartSection - isVisible - Start');
		const isFeatureToggleEnabled = this.audioSmartSettingsService.getFeatureToggle();
		if (!isFeatureToggleEnabled) {
			this.logger.info('AudioPage - AudioSmartSection - isVisible - end', false);
			return Promise.resolve(false);
		}
		const isArm = await this.deviceService.IsArm();
		if (isArm) {
			this.logger.info('AudioPage - AudioSmartSection - isVisible - end', false);
			return Promise.resolve(false);
		}
		try {
			const hasCapability = await this.audioSmartSettingsService.getCapability();
			const isVisible = hasCapability;
			this.logger.info('AudioPage - AudioSmartSection - isVisible - end', isVisible);
			return isVisible;
		} catch (error) {
			this.logger.error('AudioPage - AudioSmartSection - getCapability - error', error);
		}
		return undefined;
	}
}
